import { C } from '../theme';
import { Icon } from '../icons';
import { fmtPeriod } from '../format';

/** Shift a "YYYY-MM" period by ±1 month. */
function shiftPeriod(period: string, delta: number): string {
  const [y, m] = period.split('-').map(Number);
  const idx = (y * 12 + (m - 1)) + delta;
  const ny = Math.floor(idx / 12);
  const nm = (idx % 12) + 1;
  return `${ny}-${String(nm).padStart(2, '0')}`;
}

/**
 * ‹ prev · Month YYYY · next › — the working month control (replaces the dead
 * dropdown). Steps the selected month and re-fetches the overview for it.
 */
export function MonthStepper({
  period,
  onChange,
  compact = false,
}: {
  period: string;
  onChange: (period: string) => void;
  compact?: boolean;
}) {
  const btn: React.CSSProperties = {
    border: 0,
    background: 'transparent',
    color: C.ink2,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: compact ? 2 : 4,
  };
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: compact ? 4 : 8,
        background: C.card,
        border: `1px solid ${C.line}`,
        borderRadius: 9,
        padding: compact ? '4px 6px' : '5px 8px',
      }}
    >
      <button onClick={() => onChange(shiftPeriod(period, -1))} aria-label="Previous month" style={btn}>
        <Icon n="chev" size={compact ? 15 : 17} style={{ transform: 'scaleX(-1)' }} />
      </button>
      <span
        style={{
          fontWeight: 600,
          fontSize: compact ? 12.8 : 13.5,
          color: C.ink,
          minWidth: compact ? 92 : 104,
          textAlign: 'center',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 6,
        }}
      >
        {!compact && <Icon n="cal" size={15} />} {fmtPeriod(period)}
      </span>
      <button onClick={() => onChange(shiftPeriod(period, 1))} aria-label="Next month" style={btn}>
        <Icon n="chev" size={compact ? 15 : 17} />
      </button>
    </div>
  );
}
